<template>
  <div></div>
</template>

<script>
//TODO: Would be better if we didn't have to loop through every card and instead were able to only do one card per week

import { db } from '../../assets/js/firebase/db.js';
import moment from 'moment';
import { getHolidays } from '../../assets/js/helpers/holidays.js';
import { roundToQuarter } from '../../assets/js/helpers/hoursCalculations.js';

export default {
  name: 'WeeklyOT',
  data() {
    return {
      startDate: null,
      endDate: null,
      employee: null,
      holidays: [],
      weekDates: [],
      otCardIDs: [],
      hasOT: false
    };
  },
  props: {
    id: null,
    date: null,
    uid: null,
    name: null
  },
  methods: {
    calculateOT: function() {
      this.employee = { id: this.uid, name: this.name };
      this.startDate = moment(this.date)
        .startOf('week')
        .startOf('day');
      this.endDate = moment(this.date)
        .endOf('week')
        .endOf('day');

      this.getTimeCards(this.employee, this.startDate, this.endDate);
    },

    getTimeCards: async function(employee, startDate, endDate) {
      let startYear = parseInt(moment(startDate).format('YYYY'));
      let numberOfYears =
        parseInt(moment(endDate).format('YYYY')) -
        parseInt(moment(startDate).format('YYYY'));
      //get the list of holidays for the years that the user has selected.
      for (let i = 0; i <= numberOfYears; i++) {
        await getHolidays(startYear.toString())
          .then(response => {
            for (
              let i = 0;
              i <= response.data.provinces[0].holidays.length - 1;
              i++
            ) {
              this.holidays.push(response.data.provinces[0].holidays[i].date);
            }
          })
          .catch(err => {
            console.log(`Error getting holidays: ${err.message}`);
            this.showError('Unexpected error: Error getting holiday data.');
          });
        startYear++;
      }

      let query = db
        .collection('timeCards')
        .where('date', '>=', new Date(startDate))
        .where('date', '<=', new Date(moment(this.date).endOf('day')))
        .where('company', '==', this.$store.state.userCompany)
        .where('user', '==', employee.id);
      //run out to the store and grab a pack of time cards.
      await query.get().then(querySnapshot => {
        let tempArg = {
          employeeId: employee.id,
          timeCards: []
        };
        querySnapshot.forEach(doc => {
          // console.log(doc.data());
          let complete = true;
          for (let i = 0; i <= doc.data().times.length - 1; i++) {
            if (doc.data().times[i].endTime == null) {
              complete = false;
            }
          }
          if (complete) {
            tempArg.timeCards.push({
              id: doc.id,
              date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
              times: doc.data().times,
              approved: doc.data().approved,
              approvedBy:
                doc.data().approvedBy == undefined
                  ? null
                  : doc.data().approvedBy,
              name: doc.data().name,
              type: doc.data().type,
              dateApproved:
                doc.data().dateApproved == undefined
                  ? null
                  : moment(doc.data().dateApproved.toDate()).format(
                      'MMM DD, YY hh:mm'
                    ),
              vacation: doc.data().vacation,
              uid: doc.data().user,
              editComment:
                doc.data().editComment != undefined
                  ? doc.data().editComment
                  : null,
              incomplete: !complete
            });
          }
        });
        let sum = 0;

        for (let i = 0; i <= tempArg.timeCards.length - 1; i++) {
          let daysum = 0;
          for (let t = 0; t <= tempArg.timeCards[i].times.length - 1; t++) {
            tempArg.timeCards[i].times[t] = {
              times: [
                tempArg.timeCards[i].times[t].startTime.toDate(),
                tempArg.timeCards[i].times[t].endTime != undefined
                  ? tempArg.timeCards[i].times[t].endTime.toDate()
                  : undefined
              ],
              type: tempArg.timeCards[i].times[t].type,
              notes: tempArg.timeCards[i].times[t].notes
            };
            let start = moment(tempArg.timeCards[i].times[t].times[0]);
            let end = moment(tempArg.timeCards[i].times[t].times[1]);
            if (
              !this.holidays.includes(
                moment(tempArg.timeCards[i].date).format('YYYY-MM-DD')
              )
            ) {
              // daysum += moment.duration(end.diff(start)).asHours();
              daysum += Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
            }
            if (
              tempArg.timeCards[i].times[t].type == 'travel time' ||
              tempArg.timeCards[i].times[t].type == 'on call' ||
              tempArg.timeCards[i].times[t].type == 'ot exempt'
            ) {
              //the travel time and on call times need to be removed from the weekly ot count.
              daysum -= Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
            }
          }
          //sum all regular hours and check if OT applies and store all corresponding cards ids in array
          if (tempArg.timeCards[i].type == 'employee') {
            if (roundToQuarter(daysum) >= 8) {
              sum += 8;
            } else {
              sum += Number(roundToQuarter(Number(daysum)));
            }

            if (sum >= 44) {
              this.otCardIDs.push(tempArg.timeCards[i].id);
              this.hasOT = true;
            } else {
              this.hasOT = false;
            }
          } else if (tempArg.timeCards[i].type == 'driver') {
            if (roundToQuarter(daysum) >= 10) {
              sum += 10;
            } else {
              sum += parseFloat(roundToQuarter(parseFloat(daysum)));
            }

            if (sum >= 50) {
              this.otCardIDs.push(tempArg.timeCards[i].id);
              this.hasOT = true;
            } else {
              this.hasOT = false;
            }
          }
          if (this.date === tempArg.timeCards[i].date) {
            this.$emit('setWeeklyHours', sum);
          }
        }

        //check array for id's of cards in overtime and change header if id matches
        for (let i = 0; i < this.otCardIDs.length; i++) {
          if (this.id === this.otCardIDs[i]) {
            if (this.hasOT) {
              this.$emit('change-header', true);
            } else {
              this.$emit('change-header', false);
            }
          }
        }
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    }
  },
  created() {
    this.calculateOT();
  }
};
</script>

<style scoped></style>
